export default (props) => {
    return [
      {
        name: "ATIVO",
        label: "Ativo",
        options: {
          filter: false,
          download: false,
          customBodyRender: props.renderAtivo,
        }
      },
      {
        name: "DESCRICAO",
        label: "Descrição",
        options: {
            display: "true",
            filter: true,
            download: false,
            viewColumns: false,
        }
      },
    ];
  };
